import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import '../../styles/muiStyles.css';

const steps = [
  'Register With Mobile no.',
  'Enter Car Details',
  'Select City For Inspection',
  'Verify Payment Details',
];

const CustomizedSteppers = ({ activeStep, pageData }) => {
  return (
    <Box sx={{ width: '75%' }}>
      <Stepper
        activeStep={activeStep}
        alternativeLabel
        sx={{
          '& .MuiStepIcon-root': {
            color: '#ddd', // Default color
            width: '1.5em',
            height: '1.5em',
          },
          '& .MuiStepIcon-root.Mui-active': {
            color: '#3498db', // Active step color
          },
          '& .MuiStepIcon-root.Mui-completed': {
            color: '#2ecc71', // Completed step color
          },
          '& .MuiStepConnector-root': {
            top: '16px',
            color: 'red',
          },
          '& .MuiStepConnector-line': {
            borderColor: 'blue',
          },
        }}
      >
        {pageData?.planDetails?.steps?.map((label) => (
          <Step key={label}>
            <StepLabel>{''}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <div className="stepper-labels">
        <h6>{pageData?.planDetails?.steps?.[activeStep]}</h6>
      </div>
    </Box>
  );
};
export default CustomizedSteppers;
